app.controller('mainController', function ($scope, $rootScope, $routeParams, $location, $window, safeApply) {

	ej.base.registerLicense("Mgo+DSMBaFt+QHJqXU1hXk5Hd0BLVGpAblJ3T2ZQdVt5ZDU7a15RRnVfRF1mSH5Sd0ZkXHdbdg==;Mgo+DSMBPh8sVXJ1S0R+VFpFdEBBXHxAd1p/VWJYdVt5flBPcDwsT3RfQF5jT35Wd0ViWHxZdnRUQA==;ORg4AjUWIQA/Gnt2VFhiQllPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXhTc0RjWH5dd3JUQWY=;MjMxNDQwOEAzMjMxMmUzMDJlMzBvcmtmWEZHdk5iWWw5cHlNSnIrQnpjNWxKQ2xiK2luM3lETm8xTEN2K3prPQ==;MjMxNDQwOUAzMjMxMmUzMDJlMzBOYnpLSG40ME1JeVFLNW9xam9SaGVyWFM5cmxoTnpzWkVKd2lKMnp2Z0QwPQ==;NRAiBiAaIQQuGjN/V0d+Xk9MfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5VdkBiWX5fc3NTT2Na;MjMxNDQxMUAzMjMxMmUzMDJlMzBIcUJvUkx3UFhGVzB5eWRBZ2tkRmhiZndWMU1GR0NtU3lrTnFvUHI5UXlJPQ==;MjMxNDQxMkAzMjMxMmUzMDJlMzBIZG5HUW5XMzI3dm0zOEVMZjAxZk5wRUZTSlFkZ3EyQUl3dFFNdVliOVkwPQ==;Mgo+DSMBMAY9C3t2VFhiQllPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXhTc0RjWH5dd3NcR2Y=;MjMxNDQxNEAzMjMxMmUzMDJlMzBaZENmS2M5UTBTR3p5aEpUcTBkOUZUdWVYWnJ4YjBRTnFwTkREMjBESlZBPQ==;MjMxNDQxNUAzMjMxMmUzMDJlMzBYZ0FtV3NMVG1NbTc1djVWZXVveXJ5YnhFREdaOHRWYVBXNml1QndWQ1FBPQ==;MjMxNDQxNkAzMjMxMmUzMDJlMzBIcUJvUkx3UFhGVzB5eWRBZ2tkRmhiZndWMU1GR0NtU3lrTnFvUHI5UXlJPQ==");

	const params = $routeParams

	$scope.initializing = true

	initController()

	async function initController() {




		safeApply($scope)
	}

})
